import "./Navbar.scss"

export default {
	name: "eiis-navbar",
  props: {
    brand: String, brandimage: String, alignment: String, placement: String, 
		tint: String, hidelogin: Boolean, hidesignup: Boolean, 
    items: Array
  },
	data() {
		return {
		}
	},
  computed: {
    computedClasses() {
      let c = (this.placement == 'default' ? '' : this.placement);
      // TODO c += (this.alignment == 'center' ? 'centered mx-auto' : this.alignment);
			if (this.tint)
				c = c + " navbar-" + this.tint;
      return c;
		}
  },
  methods: {
    getString: function (key) {
      // TODO lookup language string based on the key
      let str = key;
      return str;
		}
  },
  template: `
    <nav class="eiis-navbar navbar navbar-expand-lg" role=navigation aria-label="main navigation"
        v-bind:class=computedClasses>
			<div class="container-fluid eiis-navbar-area">
        <a class="navbar-brand" href="/">
				  	<eiis-image v-if=brandimage :image='brandimage' class='d-inline-block align-middle' style='margin-right:10px' alt=''></eiis-image>
					<b class='d-inline-block align-middle'>{{brand}}</b>
				</a>
				<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapser" aria-controls="navbarCollapser" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>

	      <div class="collapse navbar-collapse" id="navbarCollapser">
					<ul class="navbar-nav me-auto mb-2 mb-lg-0">
	          <div v-for="item in items">
	            <li class="nav-item" v-if=!item.IsDropdown>
	              <i v-bind:class=item.Icon v-if=item.Icon></i>
								<a class="nav-link eiis-nav-link active" aria-current="page" v-bind:href=item.URL>
									{{item.Text}}
								</a>
	            </li>

	            <li class="nav-item dropdown" v-if=item.IsDropdown>
	              <a class="nav-link eiis-nav-link active v-bind:href=item.URL dropdown-toggle" href="#" id="navbarDropdown" 
								    role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
	                {{item.Text}}
	              </a>
	              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
	                <div v-for="subitem in item.Items">
	                  <li><a class="dropdown-item" v-bind:href=subitem.URL>{{subitem.Text}}</a></li>
	                  <li><hr class="dropdown-divider" v-if=subitem.IsDivider></li>
	                </div>
	              </ul>
	            </li>
	          </div>
	        </ul>

	        <div>
						<div class="d-flex">
	     				<div class="navbar-item" v-if=!hidesignup>
	          		<eiis-button class="eiis-navbar-link" type="btn-link" href="/signup">
	            		<strong>Sign up</strong>
	          		</eiis-button>
	        		</div>
	     				<div class="navbar-item" v-if=!hidelogin>
	          		<eiis-button class="eiis-navbar-button" type="btn-primary" href="/login">
	            		{{getString("Login")}}
	          		</eiis-button>
	      			</div>
	    			</div>
	        </div>
	      </div>
	    </div>
  	</nav>
  	`
}